import styled from 'styled-components';

const Wrapper = styled.article`
  background: #fff;
  border-radius: 14px;
  border: 1px solid #e2e8f0;
  box-shadow: 0 1px 4px rgba(15, 23, 42, 0.05);
  display: grid;
  grid-template-rows: 1fr auto;
  transition: box-shadow 0.2s, transform 0.2s, border-color 0.2s;

  &:hover {
    box-shadow: 0 6px 24px rgba(15, 23, 42, 0.09);
    transform: translateY(-2px);
    border-color: #c7d2fe;
  }

  header {
    padding: 1.25rem 1.25rem 1rem;
    border-bottom: 1px solid #f1f5f9;
    display: grid;
    grid-template-columns: auto 1fr;
    align-items: center;
    gap: 0;
  }

  .main-icon {
    width: 50px;
    height: 50px;
    display: grid;
    place-items: center;
    background: linear-gradient(135deg, #6366f1, #8b5cf6);
    border-radius: 12px;
    font-size: 1.25rem;
    font-weight: 700;
    text-transform: uppercase;
    color: #fff;
    margin-right: 1rem;
    flex-shrink: 0;
  }

  .info {
    h5 {
      font-size: 0.95rem;
      font-weight: 700;
      color: #0f172a;
      margin-bottom: 0.15rem;
      letter-spacing: -0.01em;
    }
    p {
      margin: 0;
      font-size: 0.8rem;
      text-transform: capitalize;
      color: #94a3b8;
    }
  }

  .pending {
    background: #fef3c7;
    color: #d97706;
  }
  .interview {
    background: #eef2ff;
    color: #6366f1;
  }
  .declined {
    background: #fee2e2;
    color: #dc2626;
  }
  .offer {
    background: #d1fae5;
    color: #059669;
  }

  .content {
    padding: 1rem 1.25rem 0;
  }

  .content-center {
    display: grid;
    grid-template-columns: 1fr;
    row-gap: 0.35rem;
    @media (min-width: 576px) { grid-template-columns: 1fr 1fr; }
    @media (min-width: 992px) { grid-template-columns: 1fr; }
    @media (min-width: 1120px) { grid-template-columns: 1fr 1fr; }
  }

  .status {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    border-radius: 100px;
    text-transform: capitalize;
    font-size: 0.72rem;
    font-weight: 700;
    letter-spacing: 0.03em;
    padding: 0.25rem 0.75rem;
    width: auto;
    height: auto;
    margin-top: 0.75rem;
  }

  footer {
    padding: 0.875rem 1.25rem;
    border-top: 1px solid #f1f5f9;
    margin-top: 0.75rem;
    display: flex;
    gap: 0.5rem;
  }

  .edit-btn,
  .delete-btn {
    padding: 0.4rem 0.875rem;
    border: none;
    border-radius: 8px;
    font-size: 0.78rem;
    font-weight: 700;
    cursor: pointer;
    text-transform: capitalize;
    transition: opacity 0.15s, transform 0.15s;
    &:hover { opacity: 0.85; transform: translateY(-1px); }
  }

  .edit-btn {
    background: #eef2ff;
    color: #4f46e5;
  }

  .delete-btn {
    background: #fee2e2;
    color: #dc2626;
  }
`;

export default Wrapper;
